<template>
  <v-card v-if="!isMobile" height="100%">
    <v-navigation-drawer permanent>
      <v-list-item class="pt-3">
        <v-list-item-content>
          <v-list-item-title class="body-heading-small text-center">
            Points Balance
          </v-list-item-title>
          <v-list-item-subtitle>
            <v-row justify="center" align="center">
              <v-col cols="12" md="12" class="d-flex justify-center align-center">
                <v-icon size="50" color="secondary">fas fa-gem</v-icon>
              </v-col>
              <v-col cols="12" md="12" class="d-flex justify-center align-center">
                <div class="body-heading-small">{{ user.points }}</div>
              </v-col>
            </v-row>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list dense nav>
        <v-list-item v-for="item in items" :key="item.title" :to="{ name: item.route }">
          <v-list-item-icon v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
  export default {
    name: "PointsOverviewSideMenu",
    data() {
      return {
        items: [
          {
            index: 0,
            title: "Points Store",
            icon: "",
            route: "PointsStore",
          },
          {
            index: 1,
            title: "Auto-Reload Settings",
            icon: "",
            route: "PointsAutoReloadSettings",
          },
          {
            index: 2,
            title: "Purchase History",
            icon: "",
            route: "PointsPurchaseHistory",
          },
        ],
      };
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
      user() {
        return this.$store.getters.userInfo;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Points/PointsOverviewSideMenu.vue